import type { Column, Row } from '@innovamat/glimmer-components';
import type { ProgressReport } from '@innovamat/glow-api-client';
import type { StudentDrawerData } from '../components/student-drawer/utils/types';
import { getProgressStudentsRows } from './preprocess';

export type StudentReportData = {
  id: string;
  averageRow: Row;
  columns: Column<Row>[];
  courseOrder: number | null | undefined;
  rows: Row[];
};

export type Props = {
  adaptedReportsData?: StudentReportData[];
  mainReport: ProgressReport | null | undefined;
  mainReportData: StudentReportData;
  student: StudentDrawerData | null;
};

export const getColumnsForStudent = ({
  adaptedReportsData,
  mainReport,
  mainReportData,
  student,
}: Props): Column<Row>[] => {
  if (!student || !student.uuid) return mainReportData.columns;

  const isInMainReport = getProgressStudentsRows(mainReport).some(
    (row) => row.uuid === student.uuid
  );

  if (isInMainReport) {
    return mainReportData.columns;
  }

  for (const adaptedReportData of adaptedReportsData || []) {
    const isInAdaptedReport = adaptedReportData.rows.some(
      (row) => row.uuid === student.uuid
    );
    if (isInAdaptedReport) {
      return adaptedReportData.columns;
    }
  }

  return mainReportData.columns;
};
